import { ResetPasswordForm } from '@/components/auth/resetPasswordForm';
import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(forgot-password)/reset-password')(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('forgotPassword.setNewPassword.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          { t('forgotPassword.setNewPassword.description', { ns: 'auth' }) }
        </CardDescription>
      </CardHeader>

      <CardContent className="pt-space-lg">
        <ResetPasswordForm />
      </CardContent>
    </>
  );
}
